//#region package.json
var version = "1.6.0";
//#endregion
export { version };
